
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  
  // Get user info from localStorage (simulated)
  const user = JSON.parse(localStorage.getItem('user') || '{"name": "User", "isTeacher": false}');
  
  const handleSignOut = () => {
    localStorage.removeItem('user');
    navigate('/auth/login');
  };
  
  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-3">
          <img 
            src="https://static.readdy.ai/image/1624bf5855e87197e9f976fe97d0b1c6/f0cc7993a40b5ead0a8769be11e7ac97.png" 
            alt="Reading Adventures Logo" 
            className="w-10 h-10"
          />
          <h1 className="text-2xl font-bold text-[#2d5a35]" style={{ fontFamily: '"Pacifico", serif' }}>
            Reading Adventures
          </h1>
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <button 
            onClick={() => navigate('/')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
              location.pathname === '/' 
                ? 'bg-[#2d5a35] text-white' 
                : 'text-[#2d5a35] hover:bg-green-50'
            }`}
          >
            <i className="ri-home-line text-xl"></i>
            <span className="font-medium">Home</span>
          </button>
          <button 
            onClick={() => navigate('/games')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
              location.pathname === '/games' 
                ? 'bg-[#2d5a35] text-white' 
                : 'text-[#2d5a35] hover:bg-green-50'
            }`}
          >
            <i className="ri-gamepad-line text-xl"></i>
            <span className="font-medium">Games</span>
          </button>
          <button 
            onClick={() => navigate('/progress')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
              location.pathname === '/progress' 
                ? 'bg-[#2d5a35] text-white' 
                : 'text-[#2d5a35] hover:bg-green-50'
            }`}
          >
            <i className="ri-bar-chart-line text-xl"></i>
            <span className="font-medium">Progress</span>
          </button>
          {user.isTeacher && (
            <button 
              onClick={() => navigate('/auth/invite')}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                location.pathname === '/auth/invite' 
                  ? 'bg-[#2d5a35] text-white' 
                  : 'text-[#2d5a35] hover:bg-green-50'
              }`}
            >
              <i className="ri-user-add-line text-xl"></i>
              <span className="font-medium">Invite Students</span>
            </button>
          )}
        </div>
        
        {/* User Menu */}
        <div className="relative">
          <button 
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-green-50 transition-colors"
          >
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              user.isTeacher ? 'bg-[#2d5a35]' : 'bg-emerald-500'
            }`}>
              <i className={`${user.isTeacher ? 'ri-graduation-cap-fill' : 'ri-user-fill'} text-white text-sm`}></i>
            </div>
            <span className="hidden md:block font-medium text-gray-700">{user.name}</span>
            <i className={`ri-arrow-down-s-line text-gray-400 transition-transform ${showUserMenu ? 'rotate-180' : ''}`}></i>
          </button>
          
          {showUserMenu && (
            <>
              {/* Backdrop */}
              <div 
                className="fixed inset-0 z-40" 
                onClick={() => setShowUserMenu(false)}
              ></div>
              
              {/* Menu */}
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50">
                <div className="px-4 py-2 border-b border-gray-100">
                  <p className="font-medium text-gray-800">{user.name}</p>
                  <p className="text-sm text-gray-500">
                    {user.isTeacher ? 'Teacher' : 'Student'}
                  </p>
                </div>
                
                {user.isTeacher && (
                  <button
                    onClick={() => {
                      setShowUserMenu(false);
                      navigate('/auth/invite');
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
                  >
                    <i className="ri-user-add-line"></i>
                    <span>Invite Students</span>
                  </button>
                )}
                
                <button
                  onClick={() => {
                    setShowUserMenu(false);
                    handleSignOut();
                  }}
                  className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 flex items-center space-x-2"
                >
                  <i className="ri-logout-box-line"></i>
                  <span>Sign Out</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
